var map = {
	"./Deputi Bidang Pencegahan_0003.jpg": 98316,
	"./Deputi Bidang Pencegahan_0004.jpg": 48945,
	"./Deputi Bidang Pencegahan_0005.jpg": 42068,
	"./Deputi Bidang Pencegahan_0006.jpg": 73797,
	"./Deputi Bidang Pencegahan_0007.jpg": 60974,
	"./Deputi Bidang Pencegahan_0008.jpg": 28988,
	"./Deputi Bidang Pencegahan_0009.jpg": 24609,
	"./Deputi Bidang Pencegahan_0010.jpg": 47384,
	"./Deputi Bidang Pencegahan_0011.jpg": 20677,
	"./Deputi Bidang Pencegahan_0012.jpg": 49532,
	"./Deputi Bidang Pencegahan_0013.jpg": 494,
	"./Deputi Bidang Pencegahan_0014.jpg": 49245,
	"./Deputi Bidang Pencegahan_0015.jpg": 52664,
	"./Deputi Bidang Pencegahan_0016.jpg": 72344,
	"./Deputi Bidang Pencegahan_0017.jpg": 44946,
	"./Deputi Bidang Pencegahan_0018.jpg": 2944,
	"./document thumbnail/thumb-1.png": 41169,
	"./document thumbnail/thumb-2.png": 50149,
	"./document/contoh nomor 1.pdf": 3683,
	"./document/sample2.pdf": 93842,
	"./document/sample3 long long name document.pdf": 43966,
	"./video thumbnail/THV PENCEGAHAN - Copy (2).jpg": 43535,
	"./video thumbnail/THV PENCEGAHAN - Copy (3).jpg": 1041,
	"./video thumbnail/THV PENCEGAHAN - Copy.jpg": 94864,
	"./video thumbnail/THV PENCEGAHAN.jpg": 83266,
	"./video thumbnail/dummy.txt": 12647,
	"./video/01 NEW PEMBACAAN DOKTRIN PERTAMA KALI_22 MARET 2023_1.mp4": 16836,
	"./video/02 BTS VIDEO DOKTRIN..mp4": 49015,
	"./video/03 NEW Mars BNN RI Rekor MURI_1.mp4": 77841,
	"./video/04 Video Deputi Bidang Cegah.mp4": 20681,
	"./video/dummy.txt": 15514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64307;